import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import {
  buildUniversalSelectSearchTerm,
  getSelectedUniversalSelectOption,
} from '~/lib/util/inquiry.util';

import { DropdownBaseProps } from './types';
import { useGetProviderStatesEnumQuery } from '~/store/services/enumerations';

interface StateDropdownProps extends DropdownBaseProps {
  label: string;
}

const StateDropdown = ({
  id,
  isInvalid = false,
  isRequired = false,
  label,
  onSelect,
  value,
}: StateDropdownProps) => {
  const { data: states } = useGetProviderStatesEnumQuery();

  const stateOptions = useMemo<UniversalSelectOption[]>(() => {
    // externalId here is actually the two-letter code (e.g. "NY")
    // including it in the search data so we can find "New York" by typing "NY"
    return (states ?? []).map(({ label, externalId }) => ({
      label,
      searchData: buildUniversalSelectSearchTerm(`${label} ${externalId}`),
      value: externalId,
    }));
  }, [states]);

  const labelId = label.split(' ').join('-').toLowerCase();
  const fullId = `${id}__${labelId}`;

  return (
    <InputGroupV2 id={fullId} isRequired={isRequired} label={label}>
      <UniversalSelect
        id={fullId}
        isInvalid={isInvalid}
        isSearchable
        isSingleSelect
        onChange={(selected: UniversalSelectOption) =>
          onSelect(selected?.value)
        }
        options={stateOptions}
        value={getSelectedUniversalSelectOption(value, stateOptions)}
      />
    </InputGroupV2>
  );
};

export default StateDropdown;
